import { analyticsOffersService } from "@/services/analytics-offers-service";
import type {
  OfferAnalyticsGroupApi,
  OfferAnalyticsSurfaceApi,
} from "@/types/analytics-offers";
import { downloadBlob } from "@/utils/downloadFile";
import { downloadAnalyticsExport } from "../../utils/analyticsFileExport";
import type { UpgradeSegment } from "./types";

export async function downloadOffersGroupExport(params: {
  hotelId: string;
  from: string;
  to: string;
  surface: OfferAnalyticsSurfaceApi;
  offerGroup: OfferAnalyticsGroupApi;
  format: "csv" | "xlsx";
}): Promise<void> {
  const blob = await analyticsOffersService.exportGroupSummary({
    hotelId: params.hotelId,
    from: params.from,
    to: params.to,
    surface: params.surface,
    offerGroup: params.offerGroup,
    format: params.format,
  });

  downloadBlob(
    blob,
    `group-${params.surface}-${params.offerGroup}-${params.hotelId}-${params.from}-${params.to}.${params.format}`,
  );
}

export async function downloadRoomUpgradeTrendExport(params: {
  hotelId: string;
  from: string;
  to: string;
  format: "csv" | "xlsx";
}): Promise<void> {
  const blob = await analyticsOffersService.exportRoomUpgradeRevenueTrend({
    hotelId: params.hotelId,
    from: params.from,
    to: params.to,
    format: params.format,
  });

  downloadBlob(
    blob,
    `room-upgrade-revenue-trend-${params.hotelId}-${params.from}-${params.to}.${params.format}`,
  );
}

/**
 * Client-side export of the Upgrade Usage donut segments. There is no backend
 * endpoint for this widget — the segment shares are derived on the client — so
 * we build the table locally the same way the Guest Path Track export does.
 * Returns `false` when there is nothing to export.
 */
export function downloadRoomUpgradeUsageExport(params: {
  hotelId: string;
  from: string;
  to: string;
  segments: UpgradeSegment[];
  format: "csv" | "xlsx";
}): boolean {
  if (params.segments.length === 0) {
    return false;
  }

  downloadAnalyticsExport(
    params.format,
    [
      {
        title: "Room Upgrade — Upgrade Usage",
        headers: ["Segment", "Share (%)"],
        rows: params.segments.map((segment) => [segment.name, segment.value]),
      },
    ],
    `room-upgrade-usage-${params.hotelId}-${params.from}-${params.to}`,
  );

  return true;
}
